import { render, staticRenderFns } from "./Classfiy.vue?vue&type=template&id=5af22e2f&scoped=true&"
import script from "./Classfiy.vue?vue&type=script&lang=js&"
export * from "./Classfiy.vue?vue&type=script&lang=js&"
import style0 from "./Classfiy.vue?vue&type=style&index=0&id=5af22e2f&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5af22e2f",
  null
  
)

export default component.exports